import Vue from '@/main'
//封装操作localstorage本地存储的方法   模块化的文件


// nodejs  基础


var storage={

    set(key,value){

        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key){

        return JSON.parse(localStorage.getItem(key));
    },
    remove(key){
        localStorage.removeItem(key);
    }

}

var sesStorage={

    set(key,value){

        // sessionStorage.setItem(key, JSON.stringify(value));
        Vue.resetSetItem(key, JSON.stringify(value));//全局监听sessionStorage的变化
    },
    get(key){
        if(sessionStorage.getItem(key)!="undefined"){
            return JSON.parse(sessionStorage.getItem(key));
        }else{
            return ""
        }
    },
    remove(key){
        Vue.resetRemoveItem(key);
    }

}

export {sesStorage,storage} ;





// WEBPACK FOOTER //
// ./src/model/storage.js